import { useSelector } from 'react-redux';

export default function usePriceLevels(step) {
    // const sectionslevels = useSelector(state => state.event.maps.sections.levels);
    const { levels, rainbow } = useSelector(state => state.event.maps.seats);

    return {
        seatslevels: levels,
        rainbow
    };
}